module.exports = __webpack_public_path__ + "img/base_patrimoine_village.f0419d4e.svg";